import React from 'react';
import './styles.css'
import bannerAsistenciaEnLinea from './AsistenciaEnLinea/banner_header_soporte.jpg';



export default function BannerAsistenciaEnLinea(props){

    return(<>
    <div className='contenedorBannerAsistenciaEnLinea'>
        <div className='bannerAsistenciaEnLinea'>
            <img src={bannerAsistenciaEnLinea}/>
        </div>
    </div>
    </>)
}